import VModal from "vue-js-modal";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VModal);
Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyC7YsP8kZubxErk7yVm4rvj9DmfJE-Vza4",
		libraries: "places"
	}
});

Vue.component('game-list', require('./../components/rugby/games/GameList').default);
Vue.component('games-map', require('./../components/rugby/games/GamesMap').default);
Vue.component('articles-page', require('../components/articles/ArticlesPage').default);
Vue.component('game-player', require('../components/rugby/games/GamePlayer').default);
Vue.component('game-vote-heading', require('../components/rugby/games/GameVoteHeading').default);
Vue.component('game-vote', require('../components/rugby/games/GameVote').default);
Vue.component('team-doughnut', require('../components/rugby/games/TeamDoughnut').default);
Vue.component('article-comments', require('./../components/articles/article/ArticleComments').default);
